import styles from './PartNotFound.css'

const PartNotFound = ({ children }) => {
  return (
    <div className={styles.PartNotFound}>
      {children}
    </div>
  )
}

export default PartNotFound
